import {csrf} from "~/lib/tools";

const url = (org_id, id) => `/dashboard/organizations/${org_id}/devices${id || ''}.json`;
const fetchDevices = async (org_id, machine_id) => {
    let path = url(org_id);
    if (machine_id) {
        path += `?machine_id=${machine_id}`;
    }
    return fetch(path)
        .then(r => r.json());
}
const upsertDevice = async (org_id, payload) => {
    return await fetch(
        url(org_id, payload.id ? '/' + id : ''),
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRF-Token": csrf()
            },
            body: JSON.stringify(payload),
        })
        .then(r => r.json());
}

const deleteDevice = async (org_id, id) => {
    return await fetch(
        url(org_id, id),
        {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRF-Token": csrf()
            }
        })
        .then(r => r.json());
}


export {fetchDevices, upsertDevice, deleteDevice}